module.exports = __webpack_public_path__ + "static/img/yun3.508f3cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yun3.png
// module id = sEeM
// module chunks = 0